<template>
  <div>
    <b-row class="">
      <div class="d-flex flex-column">
        <h5>{{ $t("reference.category") }}</h5>
        <b-card no-body style="margin-top: 10px">
          <b-list-group
            class="cursor-pointer"
            style="overflow-y: scroll; height: 600px"
          >
            <b-list-group-item :style="styleObject" @click="resetAll()">
              {{ $t("reference.show_all") }}
            </b-list-group-item>

            <b-list-group-item
              v-for="item in GET_INSTRUMENT_CATEGORIES.results"
              :key="item.id"
              class="flex flex-nowrap"
              :class="{ activeList: current === item.id }"
              @click="openTableId(item, item.id)"
            >
              <span>{{ item.title_full[$i18n.locale] }}</span>

              <b-dropdown
                id="dropdown-grouped"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="flat-primary"
                class="dropdown-icon-wrapper"
                toggle-class="p-50"
                toggle-tag="span"
                size="sm"
              >
                <template #button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="align-middle"
                  />
                </template>

                <b-dropdown-item
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  v-b-modal.modal-category
                  @click="editCategory = item"
                >
                  <feather-icon
                    class="text-primary"
                    icon="EditIcon"
                    size="15"
                  />
                </b-dropdown-item>

                <b-dropdown-item @click="deleteCategory(item)">
                  <feather-icon
                    class="text-primary"
                    icon="TrashIcon"
                    size="15"
                  />
                </b-dropdown-item>
              </b-dropdown>
            </b-list-group-item>
          </b-list-group>

          <div class="d-flex align-items-center mt-1">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              v-b-modal.modal-category
              size="sm"
              class="ml-auto"
              variant="outline-success"
              @click="editCategory = {}"
            >
              <feather-icon icon="PlusIcon" />
            </b-button>
          </div>
        </b-card>
      </div>

      <div class="d-flex flex-column mx-2" style="margin-top: 10px">
        <div class="d-flex justify-content-between align-items-center w-100">
          <AppSearchInput
            :label="$t('reference.vid_instruments') + ':'"
            :placeholder="$t('search')"
            @callback="searchInstrumentTypes"
          />
          <div>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              class="my-1 ml-4"
              variant="success"
              @click="saveXlsInstrumentTypes"
            >
              <feather-icon icon="DownloadIcon" size="16" />
              {{ $t("download") }}
            </b-button>
            <b-button
              v-if="addButton"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              v-b-modal.modal-instruments
              class="my-1 ml-1"
              variant="primary"
              @click="editModel = {}"
            >
              <feather-icon icon="PlusIcon" size="16" />
              {{ $t("add") }}
            </b-button>
          </div>
        </div>

        <b-table
          v-if="!isLoading"
          selectable
          select-mode="single"
          class="border"
          :fields="fields"
          :items="GET_INSTRUMENTS_MODEL.results"
          responsive
          :empty-text="$t('empty_text')"
          show-empty
          hover
          :selected-variant="tableSelectable"
          @row-clicked="onInstrumentRowSelected"
        >
          <template #head()="props">
            <span>{{ $t(props.label) }}</span>
          </template>

          <template #cell(title)="props">
            <span>{{ props.item.title_full[$i18n.locale] }}</span>
          </template>

          <template #cell(actions)="props">
            <div class="d-flex align-items-center">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                v-b-modal.modal-instruments
                size="sm"
                class="mt-50 mb-50"
                variant="warning"
                @click="editModel = props.item"
              >
                <feather-icon icon="EditIcon" size="15" />
              </b-button>

              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                size="sm"
                variant="danger"
                class="ml-1 mt-50 mb-50"
                @click="deleteProduct(props)"
              >
                <feather-icon icon="TrashIcon" size="15" />
              </b-button>
            </div>
          </template>
        </b-table>

        <b-card v-else>
          <Loader />
        </b-card>

        <Pagination
          :rows="GET_INSTRUMENTS_MODEL.count"
          :params="paramsInstrumentTypes"
          @refresh="refresh1()"
        />
      </div>

      <div class="d-flex flex-column" style="margin-top: 10px">
        <div class="d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center mt-1 mr-4">
            <AppSearchInput
              :label="$t('reference.model_ins') + ':'"
              :placeholder="$t('search')"
              @callback="searchInstrument"
            />

            <b-form-checkbox
              class="custom-control-success ml-2 d-flex align-items-center"
              name="check-button"
              switch
              v-model="generalSearch"
              @input="callSearchInstrument"
            />
            <span class="d-flex align-items-center mt-1">{{
              $t("general_search")
            }}</span>
          </div>
          <div>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              class=" ml-4"
              variant="success"
              @click="saveXlsInstruments"
            >
              <feather-icon icon="DownloadIcon" size="16" />
              {{ $t("download") }}
            </b-button>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              v-b-modal.modal-model-instruments
              class="mt-1 ml-1"
              variant="primary"
              @click="editModelInstrument = {}"
            >
              <feather-icon icon="PlusIcon" size="16" />
              {{ $t("add") }}
            </b-button>
          </div>
        </div>

        <div>
          <b-table
            v-if="!isLoading2"
            class="border"
            :fields="fields"
            :items="GET_INSTRUMENTS_MODEL_VARIANT.results"
            responsive
            :empty-text="$t('empty_text')"
            show-empty
          >
            <template #head()="props">
              <span>{{ $t(props.label) }}</span>
            </template>

            <template #cell(image)="props">
              <b-img
                style="height: 50px"
                class="w-auto"
                :src="props.item.image"
              />
            </template>

            <template #cell(actions)="props">
              <div class="d-flex align-items-center">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  v-b-modal.modal-model-instruments
                  size="sm"
                  class="mt-50 mb-50"
                  variant="warning"
                  @click="editModelInstrument = props.item"
                >
                  <feather-icon icon="EditIcon" size="15" />
                </b-button>

                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  class="ml-1 mt-50 mb-50"
                  size="sm"
                  variant="danger"
                  @click="deleteInstrumentsModelVariant(props)"
                >
                  <feather-icon icon="TrashIcon" size="15" />
                </b-button>
              </div>
            </template>
          </b-table>

          <b-card v-else>
            <Loader />
          </b-card>
        </div>

        <Pagination
          :rows="GET_INSTRUMENTS_MODEL_VARIANT.count"
          :params="paramsInstrument"
          @refresh="refresh2()"
        />
      </div>
    </b-row>

    <categoryAddEditModal :edit-category="editCategory" />

    <instrumentsModal :edit-model="editModel" />

    <modelInstrumentsModal
      :edit-model-instrument="editModelInstrument"
      :type="type"
    />
  </div>
</template>

<script>
/* eslint-disable */
import {
  BListGroup,
  BListGroupItem,
  BCard,
  BImg,
  BDropdown,
  BDropdownItem,
  BButton,
  BRow,
  BCol,
  BTable,
  BFormCheckbox,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { mapActions, mapGetters, mapState } from "vuex";
import Pagination from "@/components/Pagination.vue";
import AppSearchInput from "@/components/AppSearchInput.vue";
import categoryAddEditModal from "./modals/categoryAddEditModal.vue";
import instrumentsModal from "./modals/instrumentsModal.vue";
import modelInstrumentsModal from "./modals/modelInstrumentsModal.vue";
import areYouSure from "@/mixins/areYouSure";
import Loader from "@/components/Loader.vue";

export default {
  components: {
    BListGroup,
    BListGroupItem,
    BCard,
    BImg,

    BDropdown,
    BDropdownItem,

    BButton,
    BRow,
    BCol,
    BTable,
    Loader,

    Pagination,
    AppSearchInput,
    categoryAddEditModal,
    instrumentsModal,
    modelInstrumentsModal,
    BFormCheckbox,
  },
  directives: {
    Ripple,
  },

  mixins: [areYouSure],

  data() {
    return {
      isLoading: false,
      isLoading2: false,
      // ===============  PRIMARY_DATA_SECTION START ===============
      paramsInstrumentTypes: {
        search: "",
        page_size: 10,
        page: 1,
      },
      paramsInstrument: {
        search: "",
        type: null,
        page_size: 10,
        page: 1,
      },
      secondTable: true,
      type: null,
      editModelInstrument: {},
      editModel: {},
      styleObject: {
        backgroundColor: "#5a9cd9",
        color: "#fff",
      },
      editCategory: {},
      current: null,
      addButton: false,
      category: null,
      generalSearch: true,
      tableSelectable: "active",

      fields: [
        {
          label: "№",
          key: "id",
        },
        {
          label: "reference.name",
          key: "title",
        },
        {
          label: "actions",
          key: "actions",
        },
      ],

      // ===============  PRIMARY_DATA_SECTION END ===============
    };
  },
  computed: {
    ...mapGetters("instruments", [
      "GET_INSTRUMENT_CATEGORIES",
      "GET_INSTRUMENTS_MODEL",
      "GET_INSTRUMENTS_MODEL_VARIANT",
    ]),
  },
  async mounted() {
    // ===============  PRIMARY_REQUESTS_SECTION START ===============
    this.isLoading = true;

    await this.FETCH_INSTRUMENTS_CATEGORY({ page_size: 1000 });
    await this.refresh1();
    await this.refresh2();

    this.isLoading = false;
    // ===============  PRIMARY_REQUESTS_SECTION END ===============
  },
  methods: {
    ...mapActions("instruments", [
      "FETCH_INSTRUMENTS_CATEGORY",
      "DELETE_INSTRUMENTS_CATEGORY",
      "FETCH_INSTRUMENTS_MODEL",
      "DELETE_INSTRUMENTS_MODEL",
      "FETCH_INSTRUMENTS_MODEL_VARIANT",
      "DELETE_INSTRUMENTS_MODEL_VARIANT",
      "EXPORT_EXCEL_INSTRUMENTS",
      "EXPORT_EXCEL_INSTRUMENT_TYPES",
    ]),

    // ===============  REFRESH_SECTION START ===============
    async refresh1() {
      await this.FETCH_INSTRUMENTS_MODEL({
        ...this.paramsInstrumentTypes,
        category: this.category,
      });
    },
    async refresh2() {
      await this.FETCH_INSTRUMENTS_MODEL_VARIANT({
        type: this.type,
        ...this.paramsInstrument,
      });
    },
    // ===============  REFRESH_SECTION END ===============

    // ===============  RESET_DATA_SECTION START ===============
    async resetAll() {
      this.isLoading = true;

      this.category = null;
      await this.refresh1();
      this.current = null;
      this.styleObject = {
        backgroundColor: "#5a9cd9",
        color: "#fff",
      };
      this.addButton = false;
      this.secondTable = false;
      this.isLoading = false;
    },
    // ===============  RESET_DATA_SECTION END ===============

    // ===============  SEARCH_SECTION START ===============
    async searchInstrumentTypes(text) {
      this.isLoading = true;
      this.paramsInstrumentTypes.search = text;
      await this.refresh1();
      this.isLoading = false;
    },
    async searchInstrument(text) {
      this.isLoading2 = true;

      if (
        this.paramsInstrument.type == null ||
        this.paramsInstrument.type == ""
      ) {
        this.$nextTick(() => {
          this.generalSearch = true;
        });
      }

      let params = {};
      this.paramsInstrument.search = text;
      console.log(this.paramsInstrument);

      params = this.paramsInstrument;
      if (this.generalSearch) {
        params.type = null;
      }

      await this.FETCH_INSTRUMENTS_MODEL_VARIANT({ ...params });
      this.isLoading2 = false;
    },
    callSearchInstrument(value) {
      if (value) {
        this.tableSelectable = "";
      } else {
        this.tableSelectable = "active";
      }
      this.searchInstrument();
    },
    // ===============  SEARCH_SECTION END ===============

    // ===============  DELETE_SECTION START ===============
    deleteCategory(item) {
      this.$_showAreYouSureModal().then((val) => {
        if (val) {
          this.DELETE_INSTRUMENTS_CATEGORY(item.id)
            .then(() => {
              this.FETCH_INSTRUMENTS_CATEGORY({ page_size: 1000 });
              // window.location.reload();
              this.$_okToast();
            })
            .catch((err) => {
              this.$_errToast(err);
            });
        }
      });
    },
    deleteProduct(props) {
      this.$_showAreYouSureModal().then((val) => {
        if (val) {
          this.DELETE_INSTRUMENTS_MODEL(props.item.id)
            .then(async () => {
              await this.refresh1();
              this.$_okToast();
            })
            .catch((err) => {
              this.$_errToast(err);
            });
        }
      });
    },
    deleteInstrumentsModelVariant(props) {
      this.$_showAreYouSureModal().then((val) => {
        if (val) {
          this.DELETE_INSTRUMENTS_MODEL_VARIANT(props.item.id)
            .then(async () => {
              await this.refresh2();
              this.$_okToast();
            })
            .catch((err) => {
              this.$_errToast(err);
            });
        }
      });
    },
    // ===============  DELETE_SECTION END ===============

    // ===============  OTHERS_SECTION START ===============

    async onInstrumentRowSelected(item) {
      this.selected = item;
      this.type = item.id;
      this.paramsInstrument.type = item.id;
      await this.refresh2();
      this.secondTable = true;
    },

    async openTableId(item, id) {
      this.isLoading = true;
      this.current = id;
      this.category = id;
      this.$route.params.category_id = id;

      await this.refresh1();

      this.styleObject = {
        backgroundColor: null,
        color: null,
      };

      this.addButton = true;
      this.secondTable = false;
      this.isLoading = false;
    },
    async saveXlsInstrumentTypes() {
      this.EXPORT_EXCEL_INSTRUMENT_TYPES({
        category: this.category,
      })
        .then((res) => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "instrument-types.xls");
          document.body.appendChild(link);
          link.click();
        })
        .catch((err) => {
          this.$_errToast("Error");
        });
    },
    async saveXlsInstruments() {
      this.EXPORT_EXCEL_INSTRUMENTS({
        type: this.type,
      })
        .then((res) => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "instruments.xls");
          document.body.appendChild(link);
          link.click();
        })
        .catch((err) => {
          this.$_errToast("Error");
        });
    },
    // ===============  OTHERS_SECTION END ===============
  },
};
</script>

<style>
.table-materials .table.b-table > tbody > .table-active,
[dir] .table.b-table > tbody > .table-active > th,
[dir] .table.b-table > tbody > .table-active > td {
  color: #fff;
  background-color: #5a9cd9 !important;
}

.activeList {
  background: #5a9cd9 !important;
  color: #fff !important;
}

.activeList svg:nth-child(1) {
  color: #fff;
}

.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

.flex span {
  width: 69%;
  text-align: left;
  user-select: none;
}

.mt-25px {
  margin-top: 25px;
}
</style>
